module.exports = __webpack_public_path__ + "static/media/haskell.38bd68c1.svg";